<div class="content-inner">
    <p class="loading"></p>
    <p class="loading-text">{{loginText}}</p>
  </div>